import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import surplusResourcesIcon from "../../../../../assets/design-revamp-company/company-detail-headers/surplus-resources-icon.svg";
import { useTranslation } from "react-i18next";
import { getWasteList } from "../../../../../apis/Business/WasteApi";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import surplusResourceGraphic from "../../../../../assets/design-revamp-company/company-detail-headers/surplus-resources-graphic.png";

const WasteIcon = () => (
  <img src={surplusResourcesIcon} alt="Travel Icon" width={76} height={76} />
);

const WasteHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  businessId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalObjWaste, setTotalObjWaste] = useState([]);
  const [systemBoundaryWaste, setSystemBoundaryWaste] = useState("");
  useEffect(() => {
    getWasteList({
      businessId: businessId,
      setTotalObj: setTotalObjWaste,
      setSystemBoundaryWaste: setSystemBoundaryWaste,
    });
  }, [businessId]);

  return (
    <CategoryComponent
      show={show}
      className={`travel-category ${className || ""}`}
      leftBoxProps={{
        icon: <WasteIcon />,
        title: t("WASTE"),
        description: t("WASTE_INTRO"),
        scopes: [{ scope: t("WASTE_SCOPE"), filled: true }],
        graphicIcons: [{ icon: surplusResourceGraphic }],
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_CATEGORY"),
            items: [
              {
                subtitle: t("EXPENSES"),
                subitems: [
                  {
                    label: "DKK",
                    value: handleToFixedNum(
                      totalObjWaste,
                      totalObjWaste?.total_expenses
                    ),
                  },
                ],
              },
              {
                subtitle: `${t("EMISSIONS")} (tCO₂e)`,
                subitems: [
                  {
                    value: handleToFixedNum(
                      totalObjWaste,
                      totalObjWaste?.total_emissions
                    ),
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjWaste?.updated_at
          ? formatDate(totalObjWaste?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      systemBoundaryProps={{
        systemBoundary: systemBoundaryWaste,
        setSystemBoundary: setSystemBoundaryWaste,
        businessId: businessId,
        totalObjCategory: totalObjWaste.category_name,
      }}
      {...props}
    />
  );
};

export default WasteHeader;
